import {useMemo} from 'external/react'
import {styled, Box, useTheme, useMediaQuery} from 'external/material'
import DashboardSidebar from './DashboardSidebar'

import DashBoardContent from './DashBoardContent'
import DashBoardContentMobile from './DashBoardContentMobile'

const StyledDashBoard = styled(Box)(dashboardStyles)

export default function DashboardPage() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('desktop'))
  const Content = useMemo(() => (isDesktop ? DashBoardContent : DashBoardContentMobile) , [isDesktop]) 
  return (
    <StyledDashBoard className="dashboardWrapper">
      <Box className="dashboardContainer">
        <Content />
        <DashboardSidebar />
      </Box>
    </StyledDashBoard>
  )
}

function dashboardStyles() {
  return {
    "&.dashboardWrapper": {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding:0,
      overflowY: 'hidden'
    },
    "& .dashboardContainer": {
      display: 'flex',
      flexGrow: 1,
      overflowY: 'hidden',
    },
  }
}
